module.exports = __webpack_public_path__ + "img/1.641f3f21.jpg";